"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleList = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const StyleList = exports.StyleList = _styledComponents.default.li.withConfig({
  displayName: "StyleList",
  componentId: "sc-1v7xz4n-0"
})(["padding:6px 0px;font-size:1.4rem;transition:padding 0.3s,height 0.3s;align-items:center;justify-content:space-between;div{font-family:Poppins;font-size:12px;font-style:normal;font-weight:400;line-height:18px;letter-spacing:0em;text-align:left;}"]);